module.exports = __webpack_public_path__ + "static/AngelaHe6-11dd2b9e04819929b53dbd8c03bfd4ea.png";